import { toJS } from 'mobx';

import type { InteractiveQuestionsData } from '@genially/contracts';
import type { HostPlayP2pClient } from '@genially/p2p-client';

export const getInteractiveQuestionsDataFromClient = (
  client: HostPlayP2pClient,
): InteractiveQuestionsData => {
  const { interactiveQuestionAnswers } = client.game.asJS;

  return Object.fromEntries(
    Object.entries(interactiveQuestionAnswers).map(([key, value]) => [
      key,
      {
        answers: value.playerUserAnswers.map(p => toJS(p.answer)),
        isResolved: value.isResolved,
      },
    ]),
  );
};
